import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../Input/Input';
import { Context } from '../Context/withContext';
import FormHalfCol from '../FormHalfCol/FormHalfCol';
import Button from '../Button/Button';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import { PathContext } from '../PathContext/PathContext';
import { defaultValues } from './defualtValues';

const schema = yup.object().shape(
  {
    gross_income: yup
      .number()
      .min(7500, 'Must be at least 7500')
      .typeError('Must be a number')
      .required('Required'),
    nett_income: yup
      .number()
      .min(600, 'Must be at least R600')
      .typeError('Must be a number')
      .max(yup.ref('gross_income'), 'Cannot be more than gross income')
      .required('Required'),
    total_monthly_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .typeError('Must be a number')
      .max(yup.ref('nett_income'), 'Must be equal to or less than Nett income')
      .required('Required'),
    rent_expense: yup
      .number()
      .positive()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
    education_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
    entertainment_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
    household_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
    home_maintenance_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
    transport_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
    other_expenses: yup
      .number()
      .min(0, 'Must be greater than or equal to 0')
      .nullable()
      .typeError('Must be a number')
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value,
      ),
  },
  ['gross_income', 'nett_income'],
);

const VehiclePart2 = () => {
  const [stepNumber, setStepNumber] = useContext(Context);
  const [formData, setFormData] = useContext(FormDataContext);
  const [path] = useContext(PathContext);

  const [rent, setRent] = React.useState(0);
  const [education, setEducation] = React.useState(0);
  const [entertainment, setEntertainment] = React.useState(0);
  const [household, setHousehold] = React.useState(0);
  const [maintenance, setMaintenance] = React.useState(0);
  const [transport, setTransport] = React.useState(0);
  const [other, setOther] = React.useState(0);

  React.useEffect(() => {
    console.log('Part 2');
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const populateForm = () => {
    for (const key in defaultValues) {
      setValue(key + '', defaultValues[key]);
    }
  };

  React.useEffect(() => {
    const total =
      parseInt(rent) +
      parseInt(education) +
      parseInt(entertainment) +
      parseInt(household) +
      parseInt(maintenance) +
      parseInt(transport) +
      parseInt(other);
    setValue('total_monthly_expenses', total);
  }, [
    rent,
    education,
    entertainment,
    household,
    maintenance,
    transport,
    other,
  ]);

  // const handleExpenseChange = (e) => {
  //   const rent = watch('rent_expense');
  //   const education = watch('education_expenses');
  //   const entertainment = watch('entertainment_expenses');
  //   const household = watch('household_expenses');
  //   const maintenance = watch('maintenance_expenses');
  //   const transport = watch('transport_expenses');
  //   const other = watch('other_expenses');

  //   // const values = getValues();
  //   // // console.log(values);
  //   // console.log('^^^^^^^^Change^^^^^^^^');
  //   // //get total expenses
  //   // const expenseFields = Object.keys(values).filter((key) =>
  //   //   key.includes('expense'),
  //   // );
  //   // console.log(expenseFields);
  //   // let total = 0;
  //   // expenseFields.forEach((field) => {
  //   //   console.log(values);
  //   //   console.log(field);
  //   //   console.log(values[field]);
  //   //   total += parseInt(values[field]) ? parseInt(values[field]) : 0;
  //   // });
  //   // setValue('total_monthly_expenses', total);
  //   // //   .reduce((acc, key) => {
  //   // //     const num = formData[key] ? formData[key] : 0;
  //   // //     return acc + num;
  //   // //   }, 0);
  //   // // setValue('total_monthly_expenses', totalExpenses);

  //   console.log('Handling change');

  //   // const formFields = Object.keys(getValues());
  //   // const values = getValues();
  //   let totalExpenses = 0;

  //   // console.log('FormFields:', formFields);
  //   // console.log('Values:', values);

  //   // formFields.forEach((field) => {
  //   //   if (field.includes('expense')) {
  //   //     console.log('Field:', field);
  //   //     const val = values[field] ? parseInt(values[field]) : 0;
  //   //     console.log('Adding value of field to totalExpenses:', val);
  //   //     totalExpenses += val;
  //   //   }
  //   // });

  //   totalExpenses =
  //     (rent ? parseInt(rent) : 0) +
  //     (education ? parseInt(education) : 0) +
  //     (entertainment ? parseInt(entertainment) : 0) +
  //     (household ? parseInt(household) : 0) +
  //     (maintenance ? parseInt(maintenance) : 0) +
  //     (transport ? parseInt(transport) : 0) +
  //     (other ? parseInt(other) : 0);

  //   setValue('total_monthly_expenses', totalExpenses);
  // };

  const onSubmit = (data) => {
    let curr = formData;
    let incomeData = {
      grossIncome: data.gross_income,
      netIncome: data.nett_income,
    };
    let expensesData = {
      totalMonthlyExpenses: data.total_monthly_expenses,
      bondRentExpenses: data['rent_expense_(does_not_refer_to_bond)']
        ? data['rent_expense_(does_not_refer_to_bond)']
        : '',
      educationExpenses: data.education_expenses ? data.education_expenses : '',
      entertainmentExpenses: data.education_expenses
        ? data.education_expenses
        : '',
      householdExpenses: data.household_expenses ? data.household_expenses : '',
      maintenanceExpenses: data.home_maintenance_expenses
        ? data.home_maintenance_expenses
        : '',
      transportExpenses: data[
        'transport_expenses_(does_not_refer_to_vehicle_installment)'
      ]
        ? data['transport_expenses_(does_not_refer_to_vehicle_installment)']
        : '',
      otherExpenses: data.other_expenses ? data.other_expenses : '',
    };
    curr.income = incomeData;
    curr.expenses = expensesData;
    if (path === 'a') {
      curr.preApproval = {
        preApprovalType: 'A',
      };
      curr.asset = {
        buyingType: 'D',
      };
    }

    console.log('Part 2:', curr);

    setFormData(curr);
    setStepNumber(stepNumber + 1);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col md:flex-row flex-wrap"
    >
      {/* <h2 className="text-3xl md:px-8 w-full uppercase font-bold my-12 text-suzBlue">
        Expenses
      </h2> */}
      <FormHalfCol>
        <Input
          type="number"
          label="Gross income"
          register={register}
          errorMessage={errors.gross_income?.message}
          required
        />
        <Input
          type="number"
          label="Nett income"
          register={register}
          errorMessage={errors.nett_income?.message}
          required
        />

        <Input
          type="number"
          label="Rent Expense (does not refer to bond)"
          register={register}
          errorMessage={errors.rent_expense?.message}
          onChange={(e) => {
            setRent(e.target.value);
            // handleExpenseChange();
          }}
        />
        <Input
          type="number"
          label="Education Expenses"
          register={register}
          errorMessage={errors.education_expenses?.message}
          onChange={(e) => {
            setEducation(e.target.value);
            // handleExpenseChange();
          }}
        />
        <Input
          type="number"
          label="Entertainment Expenses"
          register={register}
          errorMessage={errors.entertainment_expenses?.message}
          onChange={(e) => {
            setEntertainment(e.target.value);
            // handleExpenseChange();
          }}
        />
      </FormHalfCol>
      <FormHalfCol>
        <Input
          type="number"
          label="Household Expenses"
          register={register}
          errorMessage={errors.household_expenses?.message}
          onChange={(e) => {
            setHousehold(e.target.value);
            // handleExpenseChange();
          }}
        />
        <Input
          type="number"
          label="Home Maintenance Expenses"
          register={register}
          errorMessage={errors.home_maintenance_expenses?.message}
          onChange={(e) => {
            setMaintenance(e.target.value);
            // handleExpenseChange();
          }}
        />
        <Input
          type="number"
          label="Transport Expenses (does not refer to vehicle installment)"
          register={register}
          errorMessage={errors.transport_expenses?.message}
          onChange={(e) => {
            setTransport(e.target.value);
            // handleExpenseChange();
          }}
        />
        <Input
          type="number"
          label="Other Expenses"
          register={register}
          errorMessage={errors.other_expenses?.message}
          onChange={(e) => {
            setOther(e.target.value);
            // handleExpenseChange();
          }}
        />
        <Input
          type="number"
          label="Total Monthly Expenses"
          register={register}
          errorMessage={errors.total_monthly_expenses?.message}
          required
        />
      </FormHalfCol>
      <div className="flex justify-center mt-8 w-full">
        <div className="mx-4">
          <Button
            text="Back"
            action={() => {
              setStepNumber(stepNumber - 1);
            }}
          />
        </div>
        <div className="mx-4">
          <Input type="submit" label="Next" />
        </div>
      </div>
      {/* <div className="mx-4">
        <Button text="POPULATE" action={populateForm} />
      </div> */}
    </form>
  );
};

export default VehiclePart2;
